import Carga from '@/model/resource/Carga'
import DeliverySacCnhIvecoReport from '@/schema/DeliverySacCnhIvecoReport.schema'
import {ID, Resource, ResponseSerialize} from 'simpli-web-sdk'
import SacResponse from '@/model/response/SacResponse'

export default class DeliverySacCnhIvecoResponse extends Carga {

    readonly $name: string = 'DeliverySacCnhIvecoResponse'
    readonly $endpoint: string = '/user/cnhIveco/sac/report'

    get $id() {
        return this.id
    }
    set $id(val: ID) {
        this.id = val
    }

    get $schema() {
        return DeliverySacCnhIvecoReport(this)
    }

    id: ID = 0

    @ResponseSerialize(SacResponse)
    sacResponse: SacResponse | null = null

}
